import { useSelector } from "react-redux";
import {
  SelectorReturnType,
  mapResourceNameToReduxSelector,
} from "../../../selectors/resources";
import { useMemo } from "react";

const useCountSelectedProvisionedApps = () => {
  const {
    resourcesList: marketplaceProvisionedApps,
    selectedResources: selectedMarketplaceProvisionedApps,
  }: SelectorReturnType = useSelector(
    mapResourceNameToReduxSelector["marketplace_provisioned_apps"],
  );

  const list = useMemo(() => {
    return selectedMarketplaceProvisionedApps.map(
      (id) => marketplaceProvisionedApps[id],
    );
  }, [selectedMarketplaceProvisionedApps, marketplaceProvisionedApps]);

  return { multiActionsCount: list.length };
};

export default useCountSelectedProvisionedApps;
